<div class="w-full flex gap-[15px]">
    <div *ngFor="let title of titles" class="checkbox-container">
        <label class="custom-checkbox">
          <input type="checkbox" [checked]="selectedValues[title]" (change)="onCheckboxChange(title)" />
          <span class="checkmark"></span>
         <span class="font-[500] text-[14px] text-gray-500"> {{ title }}</span>
        </label>
      </div>
</div>
  
